import { serviceMaker } from "..";
import { IPagination } from "../../data/AppInterface";
import { IBranchAdvancedSearch } from "../../screens/branch/BranchListController";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";

export const GET_ALL_BRANCH = (
  pagination: IPagination,
  search: string,
  advanceSearch: IBranchAdvancedSearch
) =>
  serviceMaker(
    API_ENDPOINTS.get_all_branch.url +
      `?perPageRows=${pagination.perPageRows}&currentPage=${
        pagination.currentPage
      }&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}${
        search.length > 0 ? `&search=${encodeURIComponent(search)}` : ""
      }${advanceSearch.firmId ? `&firm_id=${advanceSearch.firmId}` : ""}&sd=${
        advanceSearch.sd
      }`,
    API_ENDPOINTS.get_all_branch.method
  );

export const GET_BRANCH_BY_ID = (id: string) =>
  serviceMaker(
    API_ENDPOINTS.get_all_branch.url + `/${id}`,
    API_ENDPOINTS.get_all_branch.method
  );
